import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=13777f1d&scoped=true&"
import script from "./ExchangeRate.vue?vue&type=script&lang=js&"
export * from "./ExchangeRate.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRate.vue?vue&type=style&index=0&id=13777f1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13777f1d",
  null
  
)

export default component.exports